module.exports = __webpack_public_path__ + "img/con2-tittle.4c04bfcb.png";